// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter, getDateFormat } from '../../../utils'
import type { FormatterArgs } from '../../../types';
import moment from 'moment'
import { HOLD_ACCEPTED_VALUES } from './hold.formatter'

const alloFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'Allo',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;

      let color;

      // here we are avoiding cases of holdFormatter, to not override its cell colors
      const today = moment().format(getDateFormat('clientShort'));
      const tomorrow = moment().add(1, 'days').format(getDateFormat('clientShort'));
      const fieldDate = moment(item.ExpDate).format(getDateFormat('clientShort'));
      if (HOLD_ACCEPTED_VALUES.includes(item.Hold)) {
        if (fieldDate === today) return
        if (fieldDate === tomorrow) return
      }

      if (item.Allo === 'Y') {
        color = 'orange';
      }

      wjcCore.addClass(elem.cell, color);
    },
  });

export default alloFormatter;
